import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useState } from "react";
import data from "../../../jsons/cnj_analysis.json";
import Page from "../../ui/page";
import "./analysis.css.scss";
import CnjAnalysis from "./cnj";
import MercatorioAnalysis from "./mercatorio";

const Analysis = () => {
  const [accordion, setAccordion] = useState({
    cnjOpen: true,
    mercatorioOpen: false,
  });

  let totalCnj = 0;

  Object.keys(data).map((court) => {
    const tribunal = data[court];

    Object.keys(tribunal).map((entidade) => {
      totalCnj += tribunal[entidade].valores;
    });
  });

  const toggleAccordion = (panel) => () => {
    let k;

    switch (panel) {
      case "cnj":
        k = "cnjOpen";
        break;
      default:
        k = "mercatorioOpen";
        break;
    }

    setAccordion({ ...accordion, [k]: !accordion[k] });
  };

  return (
    <Page headerProps={{ icon: "fas fa-chart-bar", title: "Análise" }}>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="widget-body">
            <Accordion
              onChange={toggleAccordion("cnj")}
              expanded={accordion.cnjOpen}
              defaultExpanded={false}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <div className="analysis-accordion-title">
                  <span className="analysis-title">ANÁLISE DO CNJ</span>
                </div>
              </AccordionSummary>

              <AccordionDetails>
                <CnjAnalysis data={data} totalCnj={totalCnj} />
              </AccordionDetails>
            </Accordion>

            <Accordion
              onChange={toggleAccordion("mercatorio")}
              expanded={accordion.mercatorioOpen}
              defaultExpanded={false}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <div className="analysis-accordion-title">
                  <span className="analysis-title">ANÁLISE DA MERCATÓRIO</span>
                </div>

                <div className="sparks"></div>
              </AccordionSummary>

              <AccordionDetails>
                <MercatorioAnalysis />
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Analysis;
